import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getAdminCoupons, activationStatus, deleteCoupon } from '../../actions/adminCoupons';
import moment from 'moment';
import { useHistory } from 'react-router-dom';

const Coupon = ({ coupons, getAdminCoupons, activationStatus, deleteCoupon }: any) => {
  const [page, setPage] = useState(1);
  const [confirmDeleteId, setConfirmDeleteId] = useState('');
  const history = useHistory();

  useEffect(() => {
    getAdminCoupons(page);
  }, []);

  useEffect(() => {
    if (confirmDeleteId !== '') {
      if (coupons.coupons.filter((c: any) => c._id === confirmDeleteId).length === 0) {
        setConfirmDeleteId('');
      }
    }
  }, [coupons.coupons]);

  const handleActivationStatus = (item: any) => {
    activationStatus(item._id, { isActive: !item.isActive });
  };

  const loadMore = () => {
    const newPage = page + 1;
    setPage(newPage);
    getAdminCoupons(newPage);
  };

  return (
    <div className="admin-card">
      <div className="admin-card-header">
        <p className="admin-card-title">Coupons</p>
        <button
          className="admin-dropdown-trigger"
          onClick={() => history.push('/adminpanel/coupons/newCoupon')}
          style={{ background: '#ec174f', color: '#fff', borderColor: '#ec174f' }}
        >
          + New Coupon
        </button>
      </div>

      {coupons.loading ? (
        <div className="admin-empty-state">
          <i className="fas fa-spinner fa-spin" />
          <p>Loading coupons…</p>
        </div>
      ) : coupons.coupons.length === 0 ? (
        <div className="admin-empty-state">
          <i className="fas fa-tag" />
          <p>No coupons found.</p>
        </div>
      ) : (
        <>
          <div className="admin-card-body-flush">
            <div className="table-responsive">
              <table className="admin-table">
                <thead>
                  <tr>
                    <th>Discount Code</th>
                    <th>Expiry Date</th>
                    <th>Type</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {coupons.coupons.map((item: any) => (
                    <tr key={item._id}>
                      <td style={{ fontWeight: 600, fontFamily: 'monospace' }}>{item.code}</td>
                      <td className="order-time">
                        {moment(item.expireDate).format('Do MMM YYYY')}
                      </td>
                      <td>
                        <span className="status-badge" style={{ background: item.isPercent ? '#ede9fe' : '#cce5ff', color: item.isPercent ? '#5b21b6' : '#004085' }}>
                          {item.isPercent ? 'Percentage' : 'Fixed'}
                        </span>
                      </td>
                      <td>{item.isPercent ? `${item.amount}%` : `$${item.amount}`}</td>
                      <td>
                        <span
                          className={`status-badge ${item.isActive ? 'confirmed' : 'cancelled'}`}
                        >
                          {item.isActive ? 'Active' : 'Inactive'}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 6 }}>
                          <button
                            className="admin-dropdown-trigger"
                            onClick={() => handleActivationStatus(item)}
                          >
                            {item.isActive ? 'Deactivate' : 'Activate'}
                          </button>
                          {confirmDeleteId === item._id ? (
                            <>
                              <span
                                style={{
                                  fontSize: '0.78rem',
                                  color: '#6d7175',
                                  alignSelf: 'center',
                                }}
                              >
                                Sure?
                              </span>
                              <button
                                className="admin-dropdown-trigger"
                                style={{
                                  background: '#f8d7da',
                                  color: '#721c24',
                                  borderColor: '#f8d7da',
                                }}
                                onClick={() => deleteCoupon(item._id)}
                              >
                                Yes, delete
                              </button>
                              <button
                                className="admin-dropdown-trigger"
                                onClick={() => setConfirmDeleteId('')}
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <button
                              className="admin-dropdown-trigger"
                              style={{
                                background: '#f8d7da',
                                color: '#721c24',
                                borderColor: '#f8d7da',
                              }}
                              onClick={() => setConfirmDeleteId(item._id)}
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {coupons.couponCount > coupons.coupons.length && (
            <div className="admin-card-body" style={{ display: 'flex', justifyContent: 'center' }}>
              <button className="admin-dropdown-trigger" onClick={loadMore}>
                Load more
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  coupons: state.adminCouponReducer,
});

export default connect(mapStateToProps, {
  getAdminCoupons,
  activationStatus,
  deleteCoupon,
})(Coupon);
